import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Tabs/tabs';
import buttonStyles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
import AngleLeftIcon from '@patternfly/react-icons/dist/js/icons/angle-left-icon';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import { getUniqueId, isElementInView, formatBreakpointMods } from '../../helpers/util';
import { TabButton } from './TabButton';
import { TabContent } from './TabContent';
import { getOUIAProps } from '../../helpers';
export var TabsComponent;

(function (TabsComponent) {
  TabsComponent["div"] = "div";
  TabsComponent["nav"] = "nav";
})(TabsComponent || (TabsComponent = {}));

export var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));
    _this.tabList = React.createRef();

    _this.handleScrollButtons = function () {
      if (_this.tabList.current && !_this.props.isVertical) {
        var container = _this.tabList.current; // get first element and check if it is in view

        var overflowOnLeft = !isElementInView(container, container.firstChild, false); // get last element and check if it is in view

        var overflowOnRight = !isElementInView(container, container.lastChild, false);
        var showScrollButtons = overflowOnLeft || overflowOnRight;
        var disableLeftScrollButton = !overflowOnLeft;
        var disableRightScrollButton = !overflowOnRight;

        _this.setState({
          showScrollButtons: showScrollButtons,
          disableLeftScrollButton: disableLeftScrollButton,
          disableRightScrollButton: disableRightScrollButton
        });
      }
    };

    _this.scrollLeft = function () {
      // find first Element that is fully in view on the left, then scroll to the element before it
      if (_this.tabList.current) {
        var container = _this.tabList.current;
        var childrenArr = Array.from(container.children);
        var firstElementInView;
        var lastElementOutOfView;
        var i;

        for (i = 0; i < childrenArr.length && !firstElementInView; i++) {
          if (isElementInView(container, childrenArr[i], false)) {
            firstElementInView = childrenArr[i];
            lastElementOutOfView = childrenArr[i - 1];
          }
        }

        if (lastElementOutOfView) {
          container.scrollLeft -= lastElementOutOfView.scrollWidth;
        }
      }
    };

    _this.scrollRight = function () {
      // find last Element that is fully in view on the right, then scroll to the element after it
      if (_this.tabList.current) {
        var container = _this.tabList.current;
        var childrenArr = Array.from(container.children);
        var lastElementInView;
        var firstElementOutOfView;

        for (var i = childrenArr.length - 1; i >= 0 && !lastElementInView; i--) {
          if (isElementInView(container, childrenArr[i], false)) {
            lastElementInView = childrenArr[i];
            firstElementOutOfView = childrenArr[i + 1];
          }
        }

        if (firstElementOutOfView) {
          container.scrollLeft += firstElementOutOfView.scrollWidth;
        }
      }
    };

    _this.state = {
      showScrollButtons: false,
      disableLeftScrollButton: false,
      disableRightScrollButton: false,
      shownKeys: [_this.props.activeKey] // only for mountOnEnter case

    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "handleTabClick",
    value: function handleTabClick(event, eventKey, tabContentRef, mountOnEnter) {
      var shownKeys = this.state.shownKeys;
      this.props.onSelect(event, eventKey); // process any tab content sections outside of the component

      if (tabContentRef) {
        React.Children.toArray(this.props.children).filter(function (child) {
          return child.props && child.props.tabContentRef && child.props.tabContentRef.current;
        }).forEach(function (child) {
          return child.props.tabContentRef.current.hidden = true;
        }); // most recently selected tabContent

        if (tabContentRef.current) {
          tabContentRef.current.hidden = false;
        }
      }

      if (mountOnEnter) {
        this.setState({
          shownKeys: shownKeys.concat(eventKey)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isVertical) {
        window.addEventListener('resize', this.handleScrollButtons, false); // call the handle resize function to check if scroll buttons should be shown

        this.handleScrollButtons();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.isVertical) {
        window.removeEventListener('resize', this.handleScrollButtons, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          className = _a.className,
          children = _a.children,
          activeKey = _a.activeKey,
          id = _a.id,
          isFilled = _a.isFilled,
          isSecondary = _a.isSecondary,
          isVertical = _a.isVertical,
          isBox = _a.isBox,
          leftScrollAriaLabel = _a.leftScrollAriaLabel,
          rightScrollAriaLabel = _a.rightScrollAriaLabel,
          ariaLabel = _a['aria-label'],
          component = _a.component,
          ouiaId = _a.ouiaId,
          mountOnEnter = _a.mountOnEnter,
          unmountOnExit = _a.unmountOnExit,
          inset = _a.inset,
          props = __rest(_a, ["className", "children", "activeKey", "id", "isFilled", "isSecondary", "isVertical", "isBox", "leftScrollAriaLabel", "rightScrollAriaLabel", 'aria-label', "component", "ouiaId", "mountOnEnter", "unmountOnExit", "inset"]);

      var _this$state = this.state,
          showScrollButtons = _this$state.showScrollButtons,
          disableLeftScrollButton = _this$state.disableLeftScrollButton,
          disableRightScrollButton = _this$state.disableRightScrollButton,
          shownKeys = _this$state.shownKeys;
      var uniqueId = id || getUniqueId();
      var Component = component === TabsComponent.nav ? 'nav' : 'div';
      return React.createElement(React.Fragment, null, React.createElement(Component, Object.assign({
        "aria-label": ariaLabel,
        className: css(styles.tabs, isFilled && styles.modifiers.fill, isSecondary && styles.modifiers.secondary, isVertical && styles.modifiers.vertical, isBox && styles.modifiers.box, showScrollButtons && !isVertical && styles.modifiers.scrollable, formatBreakpointMods(inset, styles), className)
      }, getOUIAProps('Tabs', ouiaId), {
        id: id && id
      }, props), React.createElement("button", {
        className: css(styles.tabsScrollButton, isSecondary && buttonStyles.modifiers.secondary),
        "aria-label": leftScrollAriaLabel,
        onClick: this.scrollLeft,
        disabled: disableLeftScrollButton,
        "aria-hidden": disableLeftScrollButton
      }, React.createElement(AngleLeftIcon, null)), React.createElement("ul", {
        className: css(styles.tabsList),
        ref: this.tabList,
        onScroll: this.handleScrollButtons
      }, React.Children.toArray(children).filter(Boolean).map(function (child, index) {
        var _a = child.props,
            title = _a.title,
            eventKey = _a.eventKey,
            tabContentRef = _a.tabContentRef,
            childId = _a.id,
            tabContentId = _a.tabContentId,
            _a$isHidden = _a.isHidden,
            isHidden = _a$isHidden === void 0 ? false : _a$isHidden,
            rest = __rest(_a, ["title", "eventKey", "tabContentRef", "id", "tabContentId", "isHidden"]);

        return isHidden ? null : React.createElement("li", {
          key: index,
          className: css(styles.tabsItem, eventKey === activeKey && styles.modifiers.current, className)
        }, React.createElement(TabButton, Object.assign({
          className: css(styles.tabsLink),
          onClick: function onClick(event) {
            return _this2.handleTabClick(event, eventKey, tabContentRef, mountOnEnter);
          },
          id: "pf-tab-".concat(eventKey, "-").concat(childId || uniqueId),
          "aria-controls": tabContentId ? "".concat(tabContentId) : "pf-tab-section-".concat(eventKey, "-").concat(childId || uniqueId),
          tabContentRef: tabContentRef
        }, rest), title));
      })), React.createElement("button", {
        className: css(styles.tabsScrollButton, isSecondary && buttonStyles.modifiers.secondary),
        "aria-label": rightScrollAriaLabel,
        onClick: this.scrollRight,
        disabled: disableRightScrollButton,
        "aria-hidden": disableRightScrollButton
      }, React.createElement(AngleRightIcon, null))), React.Children.toArray(children).filter(function (child) {
        return child && child.props.children && !(unmountOnExit && child.props.eventKey !== activeKey) && !(mountOnEnter && shownKeys.indexOf(child.props.eventKey) === -1);
      }).map(function (child, index) {
        return React.createElement(TabContent, {
          key: index,
          activeKey: activeKey,
          child: child,
          id: child.props.id || uniqueId
        });
      }));
    }
  }]);

  return Tabs;
}(React.Component);
Tabs.defaultProps = {
  activeKey: 0,
  onSelect: function onSelect() {
    return undefined;
  },
  isFilled: false,
  isSecondary: false,
  isVertical: false,
  isBox: false,
  leftScrollAriaLabel: 'Scroll left',
  rightScrollAriaLabel: 'Scroll right',
  component: TabsComponent.div,
  mountOnEnter: false,
  unmountOnExit: false
};